import {Component} from '@angular/core';

@Component({
  selector: 'app-sales-docs-privacy-policy',
  templateUrl: './sales-docs-privacy-policy.component.html',
})

export class SalesDocsPrivacyPolicyComponent {

}
